import { render, staticRenderFns } from "./SearchFilterTokens.vue?vue&type=template&id=da0ba0a4&scoped=true&"
import script from "./SearchFilterTokens.vue?vue&type=script&lang=js&"
export * from "./SearchFilterTokens.vue?vue&type=script&lang=js&"
import style0 from "./SearchFilterTokens.vue?vue&type=style&index=0&id=da0ba0a4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da0ba0a4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('da0ba0a4')) {
      api.createRecord('da0ba0a4', component.options)
    } else {
      api.reload('da0ba0a4', component.options)
    }
    module.hot.accept("./SearchFilterTokens.vue?vue&type=template&id=da0ba0a4&scoped=true&", function () {
      api.rerender('da0ba0a4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2cS0i7i8aCvJ2/JS/comp/SearchFilterTokens.vue"
export default component.exports